<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { STATE_META } from 'dashboard/helper/conversationLens';

const props = defineProps({
  state: { type: String, required: true },
  iconOnly: { type: Boolean, default: false },
});

const { t } = useI18n();

const meta = computed(() => STATE_META[props.state]);
const label = computed(() => t(meta.value.labelKey));
</script>

<template>
  <span
    v-if="iconOnly"
    :title="label"
    :class="[meta.icon, meta.iconClass]"
    class="size-3.5 shrink-0"
  />
  <span
    v-else
    class="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full"
    :class="meta.pillClass"
  >
    <span :class="meta.icon" class="size-3 shrink-0" />
    {{ label }}
  </span>
</template>
